import {observer} from "mobx-react";
import {OptionRate} from "./option-rate";
import {useOriginalRate} from "../../../infrastructure/hooks/rates/useOriginalRate";

export const OptionOriginalRate = observer(({option, controller, className, betsImpressionParams}) => {
  const originalRate = useOriginalRate(controller, option);

  const optionRateProps = {
    controller,
    className,
    betsImpressionParams
  }

  return (
   <OptionRate {...optionRateProps}>
     {originalRate}
   </OptionRate>
  )
});

